import React from 'react';

const PaymentFlow = () => {
  return (
    <svg width="529" height="214" viewBox="0 0 529 214" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <rect x="4" y="112" width="128" height="96" rx="6" fill="white" />
      </g>
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="16" y="124" width="24" height="24">
        <circle cx="28" cy="136" r="12" fill="#03363D" />
      </mask>
      <g mask="url(#mask0)">
        <circle cx="28" cy="136" r="12" fill="#13B5EA" />
        <rect x="16" y="124" width="24" height="24" fill="#C1C3C6" />
      </g>
      <rect x="16" y="174" width="46" height="4" fill="#C1C3C6" />
      <rect x="16" y="184" width="75" height="4" fill="#E6E9EC" />
      <g filter="url(#filter1_d)">
        <rect x="148" y="112" width="128" height="96" rx="6" fill="white" />
      </g>
      <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="160" y="124" width="24" height="24">
        <circle cx="172" cy="136" r="12" fill="#03363D" />
      </mask>
      <g mask="url(#mask1)">
        <circle cx="172" cy="136" r="12" fill="#13B5EA" />
        <rect x="160" y="124" width="24" height="24" fill="#C1C3C6" />
      </g>
      <rect x="160" y="174" width="46" height="4" fill="#C1C3C6" />
      <rect x="160" y="184" width="75" height="4" fill="#E6E9EC" />
      <rect x="4" width="145" height="14" fill="#E6E9EC" />
      <path
        d="M87 56.4884L81.3019 58.3724C80.3211 58.6967 79.2733 58.7623 78.2598 58.5628L75.2684 57.9741C74.7417 57.8705 74.2312 57.6966 73.7507 57.4571L71.5489 56.3598C70.2546 55.7147 68.7358 55.6992 67.4285 56.3176L66.7655 56.6312C65.2764 57.3356 63.5016 56.9799 62.3989 55.7561L62.308 55.6553C60.672 53.8396 57.7456 54.1265 56.4934 56.2253V56.2253C55.2345 58.3352 52.2873 58.6115 50.6582 56.7724L50.2305 56.2896C49.333 55.2763 47.9933 54.7711 46.6502 54.9393L46.1236 55.0052C44.4589 55.2137 42.856 54.5034 41.4703 53.5575C40.9634 53.2115 40.4387 52.9538 40 52.9538"
        stroke="#E6E9EC"
        strokeWidth="1.5"
      />
      <rect x="4" y="53" width="27" height="6" fill="#C1C3C6" />
      <rect x="5" y="74" width="92" height="4" fill="#E6E9EC" />
      <path
        d="M231 56.4884L225.302 58.3724C224.321 58.6967 223.273 58.7623 222.26 58.5628L219.268 57.9741C218.742 57.8705 218.231 57.6966 217.751 57.4571L215.549 56.3598C214.255 55.7147 212.736 55.6992 211.428 56.3176L210.765 56.6312C209.276 57.3356 207.502 56.9799 206.399 55.7561L206.308 55.6553C204.672 53.8396 201.746 54.1265 200.493 56.2253V56.2253C199.235 58.3352 196.287 58.6115 194.658 56.7724L194.231 56.2896C193.333 55.2763 191.993 54.7711 190.65 54.9393L190.124 55.0052C188.459 55.2137 186.856 54.5034 185.47 53.5575C184.963 53.2115 184.439 52.9538 184 52.9538"
        stroke="#E6E9EC"
        strokeWidth="1.5"
      />
      <rect x="148" y="53" width="27" height="6" fill="#C1C3C6" />
      <rect x="149" y="74" width="92" height="4" fill="#E6E9EC" />
      <path
        d="M375 56.4884L369.302 58.3724C368.321 58.6967 367.273 58.7623 366.26 58.5628L363.268 57.9741C362.742 57.8705 362.231 57.6966 361.751 57.4571L359.549 56.3598C358.255 55.7147 356.736 55.6992 355.428 56.3176L354.765 56.6312C353.276 57.3356 351.502 56.9799 350.399 55.7561L350.308 55.6553C348.672 53.8396 345.746 54.1265 344.493 56.2253V56.2253C343.235 58.3352 340.287 58.6115 338.658 56.7724L338.231 56.2896C337.333 55.2763 335.993 54.7711 334.65 54.9393L334.124 55.0052C332.459 55.2137 330.856 54.5034 329.47 53.5575C328.963 53.2115 328.439 52.9538 328 52.9538"
        stroke="#E6E9EC"
        strokeWidth="1.5"
      />
      <rect x="292" y="53" width="27" height="6" fill="#C1C3C6" />
      <rect x="293" y="74" width="92" height="4" fill="#E6E9EC" />
      <path
        d="M519 56.4884L513.302 58.3724C512.321 58.6967 511.273 58.7623 510.26 58.5628L507.268 57.9741C506.742 57.8705 506.231 57.6966 505.751 57.4571L503.549 56.3598C502.255 55.7147 500.736 55.6992 499.428 56.3176L498.765 56.6312C497.276 57.3356 495.502 56.9799 494.399 55.7561L494.308 55.6553C492.672 53.8396 489.746 54.1265 488.493 56.2253V56.2253C487.235 58.3352 484.287 58.6115 482.658 56.7724L482.231 56.2896C481.333 55.2763 479.993 54.7711 478.65 54.9393L478.124 55.0052C476.459 55.2137 474.856 54.5034 473.47 53.5575C472.963 53.2115 472.439 52.9538 472 52.9538"
        stroke="#E6E9EC"
        strokeWidth="1.5"
      />
      <rect x="436" y="53" width="27" height="6" fill="#C1C3C6" />
      <rect x="437" y="74" width="92" height="4" fill="#E6E9EC" />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="110"
          width="136"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="144"
          y="110"
          width="136"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default PaymentFlow;
